import React, { useState } from 'react'

// react meta tags
import { ReactTitle } from 'react-meta-tags';

// react redux
import { connect } from "react-redux";

import { useHistory } from "react-router-dom";

// formik
import { useFormik } from "formik";

// yup
import * as Yup from "yup";

// react toastify
import { toast } from "react-toastify";

// helpers | common
import {
	saveToLocalStorage,
} from "utlis/helpers/Common/CommonHelperFunctions";

// API WORK

// auth api
import { userLogin } from "utlis/Apis/Auth_API";
// cart api
import { mergeCartItems } from 'utlis/Apis/Cart_API';

// redux actions
import {
	saveCommonTokenToStore,
	saveCurrentUserToStore,
	setTempOrderId,
} from "redux/actions/actionAuth";
import { setGlobalLoading } from "redux/actions/actionCommon";
import { setCartDetails, setCartImages, setCartItem } from 'redux/actions/actionCart';

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED,
	LOGIN_SUCCESS,
} from "utlis/AppMessages/AppMessages";

// themes
import { Theme1 } from "./themes/Theme1";


import WithLoginCheck from 'routes/WithLoginCheck';

function Login(props) {
	// props
	const {
		globalAppTheme,

		setGlobalLoading,

		saveCommonTokenToStore,
		saveCurrentUserToStore,

		tempOrderId,
		setTempOrderId,

		setCartDetails,
		setCartItem,
		setCartImages
	} = props

	// consts
	const history = useHistory();
	const name_to_save_on_local_storage = `__toi_dd`

	// states
	const [buttonLoading, setButtonLoading] = useState(false);
	const [buttonDisable, setButtonDisable] = useState(false);

	//initial value
	const initialFormValues = {
		email: "",
		password: "",
	};

	// handle form validations
	const formValidationSchema = Yup.object({
		email: Yup.string().email().required("This field is required"),
		password: Yup.string()
			.min(6, "the password must be at least six characters long")
			.required("This field is required"),
	});

	const onFormSubmit = (values) => {
		// if all the values present
		if (values) {
			// enabling button loading and disabling button
			setButtonDisable(true);
			setButtonLoading(true);

			// login the user API
			userLogin(values.email, values.password).then((res) => {
				const resData = res.data;

				// if the request is success
				if (resData.success) {
					const userData = resData.data;

					// generating user details
					const currentUser = {
						loggedOn: new Date(),
						canExpire: false,
						email: userData.email,
						firstName: userData.first_name,
						lastName: userData.last_name,
						userId: userData.user_id,
						userToken: userData.user_token,
						tempOrderId: userData.temp_order_id,
					};

					// merging cart items with the already selected cart items by user
					mergeCartItems(currentUser.userToken, {
						customerId: currentUser.userId,
						from: tempOrderId,
						to: currentUser?.tempOrderId ?? ""
					}).then(res => {
						const resData = res.data

						// if request is success
						if (resData.success) {
							const accData = resData.data

							// setting new temp order id
							setTempOrderId(resData.temp_order_id)
							saveToLocalStorage(name_to_save_on_local_storage, resData.temp_order_id)

							// setting cart items details
							setCartItem(accData.content);
							setCartImages(accData.images);
							setCartDetails({
								cart_discount: accData.cart_discount,
								cart_items: accData.cart_items,
								cart_qty: accData.cart_qty,
								cart_sub_total: accData.cart_sub_total,
								cart_total: accData.cart_total,
								coupon_code: accData.coupon_code,
								coupon_value: accData.coupon_value,
								allCartData: accData
							});

							// saving user to store
							saveCurrentUserToStore(currentUser);

							// then saving the user to the local storage
							saveToLocalStorage("__uu_dd", JSON.stringify(currentUser));

							// disabling button loading
							setButtonLoading(false);

							// enabling button
							setButtonDisable(false);

							// reload the page
							window.location.reload()

							// dismissing all the previous toasts first
							toast.dismiss();

							// showing the error message
							toast.success(LOGIN_SUCCESS, {
								autoClose: 2000,
							});
						}

						// if request has some errors
						if (resData.error) {
							console.log("Login error ", resData);

							// disabling button loading
							setButtonLoading(false);

							// dismissing all the previous toasts first
							toast.dismiss();

							// showing the error message
							toast.error(resData.message || "Unknown error occured", {
								autoClose: 2500,
								onClose: () => {
									// enabling button
									setButtonDisable(false);
								},
							});
						}
					}).catch((err) => {
						console.log(`${ERROR_WHILE__NAME} mergeCartItems `, err.message);

						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(UNKNOWN_ERROR_OCCURED, {
							autoClose: 3000,
							onClose: () => {
								// disabling button loading and enabling button
								setButtonDisable(false);
								setButtonLoading(false);
							},
						});
					});
				}

				// if there's any error
				if (resData.error) {
					console.log("Login error ", resData);

					// disabling button loading
					setButtonLoading(false);

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(resData.message || "Unknown error occured", {
						autoClose: 2500,
						onClose: () => {
							// enabling button
							setButtonDisable(false);
						},
					});
				}
			}).catch((err) => {
				console.log(`${ERROR_WHILE__NAME} userLogin `, err.message);

				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 3000,
					onClose: () => {
						// disabling button loading and enabling button
						setButtonDisable(false);
						setButtonLoading(false);
					},
				});
			});
		}
	};

	// formik hook
	const formik = useFormik({
		initialValues: initialFormValues,
		validationSchema: formValidationSchema,
		onSubmit: onFormSubmit
	});

	return (
		<React.Fragment>
			{/* website title */}
			<ReactTitle title={"Login | krave Decor"} />

			{
				globalAppTheme === 'theme1' ? (
					<Theme1
						formik={formik}

						buttonLoading={buttonLoading}
						buttonDisable={buttonDisable}
					/>
				) : null
			}
		</React.Fragment>
	)
}

const getDataFromStore = (state) => {
	return {
		globalAppTheme: state.common.globalAppTheme,
		tempOrderId: state.auth.tempOrderId,
	};
};

const dispatchActionsToProps = (dispatch) => {
	return {
		setGlobalLoading: (bool) => dispatch(setGlobalLoading(bool)),
		saveCommonTokenToStore: (token) => dispatch(saveCommonTokenToStore(token)),
		saveCurrentUserToStore: (user) => dispatch(saveCurrentUserToStore(user)),
		setCartDetails: cartDetails => dispatch(setCartDetails(cartDetails)),
		setCartItem: cartData => dispatch(setCartItem(cartData)),
		setCartImages: cartData => dispatch(setCartImages(cartData)),
		setTempOrderId: orderId => dispatch(setTempOrderId(orderId)),
	};
};

export default WithLoginCheck(connect(getDataFromStore, dispatchActionsToProps)(Login));